/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventCalendarContainer_viewer$ref: FragmentReference;
export type EventCalendarContainer_viewer = {|
  +id: string,
  +calendar_token: ?string,
  +s_time_zone: ?string,
  +EventCalendar_user_events: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +event: ?{|
          +id: string,
          +title: ?string,
        |},
        +booking_status: ?BookingStatus,
        +user_event_segments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +all_day: ?boolean,
              +title: ?string,
              +start_at: ?any,
              +end_at: ?any,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref,
  +$refType: EventCalendarContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "EventCalendarContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "visibility",
      "type": "[UserEventVisibility]",
      "defaultValue": [
        "SHOW"
      ]
    },
    {
      "kind": "LocalArgument",
      "name": "booking_status",
      "type": "[BookingStatus]",
      "defaultValue": [
        "BOOKED",
        "INITIAL",
        "CANCELED"
      ]
    },
    {
      "kind": "LocalArgument",
      "name": "afterTime",
      "type": "ISO8601Type",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "beforeTime",
      "type": "ISO8601Type",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "returnEmptyConnection",
      "type": "Boolean",
      "defaultValue": true
    }
  ],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "calendar_token",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "booking_status",
          "variableName": "booking_status",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "return_empty_connection",
          "variableName": "returnEmptyConnection",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "visibility",
          "variableName": "visibility",
          "type": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "EventCalendar_user_events",
      "name": "user_events",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after_time",
          "variableName": "afterTime",
          "type": "ISO8601Type"
        },
        {
          "kind": "Variable",
          "name": "before_time",
          "variableName": "beforeTime",
          "type": "ISO8601Type"
        },
        {
          "kind": "Variable",
          "name": "booking_status",
          "variableName": "booking_status",
          "type": "[BookingStatus]"
        },
        {
          "kind": "Variable",
          "name": "return_empty_connection",
          "variableName": "returnEmptyConnection",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "visibility",
          "variableName": "visibility",
          "type": "[UserEventVisibility]"
        }
      ],
      "concreteType": "UserEventConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [
                    v0,
                    v1
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "booking_status",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_event_segments",
                  "storageKey": "user_event_segments(first:99999)",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 99999,
                      "type": "Int"
                    }
                  ],
                  "concreteType": "UserEventSegmentConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserEventSegmentEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserEventSegment",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "all_day",
                              "args": null,
                              "storageKey": null
                            },
                            v1,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "start_at",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "end_at",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '33b8cf2deec307774bb55a2831d9d415';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/List/__generated__/EventCalendarContainer_viewer.graphql.js